module.exports = __webpack_public_path__ + "img/ro.feb88609.svg";